import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Accessibility = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Accessibility" {...props}>
    <path d="M21 7C21.5523 7 22 7.44772 22 8C22 8.55228 21.5523 9 21 9H14V13.1807L19.8174 21.4229C20.1359 21.874 20.0282 22.4989 19.5771 22.8174C19.126 23.1359 18.5011 23.0282 18.1826 22.5771L12.1826 14.0771C12.1654 14.0528 12.1526 14.0257 12.1377 14H11.8633C11.8551 14.0141 11.8487 14.0292 11.8398 14.043L6.33984 22.543C6.03988 23.0065 5.42068 23.1396 4.95703 22.8398C4.49346 22.5399 4.3604 21.9207 4.66016 21.457L10 13.2041V9H3C2.44772 9 2 8.55228 2 8C2 7.44772 2.44772 7 3 7H21Z" fill="#000" /><path d="M12 2C13.1046 2 14 2.89543 14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2Z" fill="#000" />
  </StyledIcon>
));

Accessibility.displayName = 'Accessibility';

export { Accessibility };
